module.exports = __webpack_public_path__ + "img/69-005927.png";